/**
 * Wrapper nad react-katex dodający automatyczne upraszczanie współczynników ±1
 * przed zmienną w wyrażeniach LaTeX generowanych przez nasze zadania.
 *
 * Reguły:
 *  -1x  →  -x       (koef. -1 bezpośrednio przed literą)
 *   1x  →   x       (koef.  1 bezpośrednio przed literą)
 *  +\s*1x  → + x    (w środku wyrażenia)
 *
 * Bezpieczne przypadki (NIE są zmieniane):
 *  \frac{1}{x}  – "1" poprzedza "}", nie literę
 *  10x, 21x     – "1" poprzedzone inną cyfrą (lookbehind)
 *  11x          – "1" poprzedzone cyfrą → bezpieczne
 */

import {
  InlineMath as KatexInlineMath,
  BlockMath as KatexBlockMath,
} from "react-katex";

function fixLatex(str) {
  if (typeof str !== "string") return str;
  return str
    // -1x → -x  (najpierw, żeby nie zepsuć kolejnego kroku)
    .replace(/(?<![0-9])-1([a-zA-Z])/g, "-$1")
    // 1x → x  (poprzedzone czymś innym niż cyfra)
    .replace(/(?<![0-9])1([a-zA-Z])/g, "$1");
}

export function InlineMath({ math, ...rest }) {
  return <KatexInlineMath math={fixLatex(math)} {...rest} />;
}

export function ReadableInlineMath({ math, scale = 1.35, verticalAlign = "-0.12em", ...rest }) {
  // Wymuszamy display style, żeby ułamki (\frac) renderowały się w pełnej
  // wielkości – tak jak w zadaniach zamkniętych (InlineMath + \displaystyle),
  // a nie jako małe ułamki textstyle.
  const displayMath =
    typeof math === "string" ? `\\displaystyle ${fixLatex(math)}` : fixLatex(math);
  return (
    <span
      style={{
        display: "inline-block",
        fontSize: `${scale}em`,
        lineHeight: 1,
        verticalAlign,
      }}
    >
      <KatexInlineMath math={displayMath} {...rest} />
    </span>
  );
}

export function ChoiceLabel({ letter, dot = true }) {
  return <InlineMath math={`${letter}${dot ? "." : ""}`} />;
}

export function ChoiceOptionMath({ letter, math, space = "\\;", display = false }) {
  const body = display ? `\\displaystyle ${math}` : math;
  return <InlineMath math={`${letter}.${space}${body}`} />;
}

export function BlockMath({ math, ...rest }) {
  return <KatexBlockMath math={fixLatex(math)} {...rest} />;
}
